export const MISSING_REQUIRED_INFORMATION = "Missing required information";
